import { t } from '../../i18n.es.js';
import React from 'react';
import slug from '@teko/slug';
import { styled, LazyImage, NumberStepperAllowBlank } from '@teko/ui';
import { CustomLink } from '../../Common/CustomLink/CustomLink.es.js';
import { ProductPrice } from '../../mobile/ProductPrice/ProductPrice.es.js';
import { TableDivider } from '../TableDivider/TableDivider.es.js';

const OrderItemsWrapper = styled.table`
  margin: 16px 8px 0 8px;
  border-radius: 8px;
  border: 1px solid #e4e5f0;
  background-color: white;
  overflow: hidden;
  font-size: 14px;
  color: #333;
  border-spacing: 0;
  border-collapse: initial;
  table-layout: fixed;
  width: 98%;

  p {
    margin: 0;
    padding: 0;
  }

  thead {
    background: #e4e5f0;
  }

  td {
    vertical-align: top;
  }

  th {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    padding: 16px;

    &:nth-of-type(1) {
      width: 60%;
    }
    &:nth-of-type(2) {
      width: 20%;
    }
    &:nth-of-type(3) {
      width: 20%;
    }
  }
`;
const OrderProduct = styled.tr`
  td {
    padding: 16px;
  }
`;
const ProductItem = styled.td`
  display: flex;
`;
const ProductItemRight = styled.div`
  margin-left: 16px;

  & > :not(:last-child) {
    margin-bottom: 4px;
  }
`;
const ItemImg = styled(LazyImage)`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin: 0;
  padding: 0;
  max-width: 56px;
`;
const ItemName = styled.p`
  word-wrap: break-word;
  line-height: 20px;
`;
const ItemQuantity = styled.td`
  text-align: center;
`;
const ItemReturnQuantity = styled.td`
  text-align: center;
`;
const TableHead = styled.th(({ direction }) => `
    text-align: ${direction};
    font-weight: 700 !important;
  `);
const QuantitySelect = styled.div`
  text-align: center;
  width: 120px;
  float: right;
`;
const Stepper = styled(NumberStepperAllowBlank)`
  border: 1px solid #e4e5f0;
  border-radius: 4px;
  button {
    outline: none;
  }
`;
const OrderPrize = styled.tr`
  td {
    padding: 0 16px 8px 16px;
  }
`;
const PrizeItem = styled.td(({ last }) => `
    padding-left: 40px !important;
    padding-bottom: ${last ? "16px !important" : ""};
  `);
const PrizeImg = styled(ItemImg)`
  margin-right: 16px;
  width: 32px;
  height: 32px;
  max-width: 32px;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
`;
const PrizeName = styled(ItemName)`
  font-size: 12px;
  line-height: 16px;
  color: #333;
`;
const GiftsWrapper = styled.div`
  display: flex;
  background: #f8f8fc;
  padding: 8px;
  margin-top: -10px;
  border-radius: 8px;
`;
const EditableDetailTable = ({
  products,
  onChangeQuantity,
  showQuantityError = false
}) => {
  return /* @__PURE__ */ React.createElement(OrderItemsWrapper, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(TableHead, {
    direction: "left"
  }, t("S\u1EA3n ph\u1EA9m")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "center"
  }, t("S\u1ED1 l\u01B0\u1EE3ng")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "center"
  }, t("Tr\u1EA3 l\u1EA1i")))), /* @__PURE__ */ React.createElement("tbody", null, products.map((product, index) => {
    var _a;
    return /* @__PURE__ */ React.createElement(React.Fragment, {
      key: product.sku
    }, /* @__PURE__ */ React.createElement(OrderProduct, null, /* @__PURE__ */ React.createElement(ProductItem, null, /* @__PURE__ */ React.createElement(ItemImg, {
      src: product.imageUrl || "",
      alt: "item"
    }), /* @__PURE__ */ React.createElement(ProductItemRight, null, /* @__PURE__ */ React.createElement(CustomLink, {
      targetPath: `/${slug(product.name)}-s${product.sku}.html`,
      targetType: "_blank",
      passHref: true
    }, /* @__PURE__ */ React.createElement(ItemName, null, product.displayName || product.name)), /* @__PURE__ */ React.createElement(ProductPrice, {
      marginTop: "4px",
      price: product.price,
      listedPrice: product.unitPrice,
      variant: "normal"
    }))), /* @__PURE__ */ React.createElement(ItemQuantity, null, product.quantity.toLocaleString("vi-VN")), /* @__PURE__ */ React.createElement(ItemReturnQuantity, null, /* @__PURE__ */ React.createElement(QuantitySelect, null, /* @__PURE__ */ React.createElement(Stepper, {
      setValue: (newValue) => {
        onChangeQuantity == null ? void 0 : onChangeQuantity(newValue, product.sku);
      },
      value: 0,
      maximumValue: product.quantity,
      variant: "normal",
      showError: showQuantityError
    })))), (_a = product.prizes) == null ? void 0 : _a.map(({ name, imageUrl }, index2) => {
      var _a2;
      return /* @__PURE__ */ React.createElement(OrderPrize, {
        key: index2
      }, /* @__PURE__ */ React.createElement(PrizeItem, {
        last: (((_a2 = product.prizes) == null ? void 0 : _a2.length) || 0) - 1 === index2,
        colSpan: 3
      }, /* @__PURE__ */ React.createElement(GiftsWrapper, null, /* @__PURE__ */ React.createElement(PrizeImg, {
        src: imageUrl || "",
        alt: "item"
      }), /* @__PURE__ */ React.createElement(PrizeName, null, name))));
    }), index !== products.length - 1 && /* @__PURE__ */ React.createElement(TableDivider, {
      colCount: 3
    }));
  })));
};

export { EditableDetailTable };
